var exports = {
  "kL": "x804f0401--a5159c--container",
  "kb": "x804f0401--a5159c--left",
  "pG": "x804f0401--a5159c--right",
  "mj": "x804f0401--a5159c--like",
  "QZ": "x804f0401--a5159c--dislike",
  "ZF": "x804f0401--a5159c--answer",
  "Jh": "x804f0401--a5159c--answer_visbility",
};

module.exports = exports;
